import styled, { keyframes } from 'styled-components';
import { compose } from 'styled-system';

import Button from '../Button';
import {
  BORDER,
  COMMON,
  LAYOUT,
  SystemBorderProps,
  SystemCommonProps,
  SystemLayoutProps
} from '../theme/constants';
import sx, { SxProp } from '../theme/utils/sx';

const composeSystem = compose(COMMON, LAYOUT, BORDER);

type ComposeSystemProps = SystemCommonProps &
  SystemLayoutProps &
  SystemBorderProps;

export const StyledModalContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  right: 0px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 99999;
  overflow-y: auto;
  overflow-y: overlay;
  padding: 16px;
`;

const opacityIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Backdrop = styled.div<{ open: boolean }>`
  position: fixed;
  background-color: rgba(71, 71, 71, 0.6);
  right: 0px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 9999;
  opacity: ${({ open }) => (open ? '1' : '0')};
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.6, 1);
  animation: 225ms cubic-bezier(0.4, 0, 0.6, 1) 0s 1 ${opacityIn};
  will-change: opacity;
`;

const opacityAndScaleIn = keyframes`
  0% {
    opacity: 0;
    transform : scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export interface StyledModalProps extends SxProp, ComposeSystemProps {
  open: boolean;
  fullWidth?: boolean;
}

export const StyledModal = styled.div<StyledModalProps>`
  box-shadow: 0 0 12px 3px rgba(125, 125, 125, 0.5);
  background-color: #ffff;
  border-radius: 4px;
  position: relative;
  animation: 225ms cubic-bezier(0.4, 0, 0.6, 1) 0s 1 ${opacityAndScaleIn};
  margin: auto;
  z-index: 99999;
  transform: ${({ open }) => (open ? 'scale(1)' : 'scale(0.9)')};
  opacity: ${({ open }) => (open ? '1' : '0')};
  transition: transform 225ms cubic-bezier(0.4, 0, 0.6, 1),
    opacity 225ms cubic-bezier(0.4, 0, 0.6, 1);
  box-sizing: border-box;
  will-change: transform, opacity;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  max-width: 100%;

  ${composeSystem}
  ${sx}
`;

StyledModal.defaultProps = {
  px: 8,
  py: 7,
  borderRadius: 24,
  maxWidth: 'sm'
};

export const ModalTitle = styled.h3`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.18;
  color: ${({ theme }) => theme.colors.grey[90]};
  margin: 0;
  flex-grow: 1;
  margin-bottom: 24px;
  margin-right: 32px;
`;

export const ModalCloseButton = styled(Button)`
  position: absolute;
  right: 24px;
  top: 24px;
`;
